import React from 'react'
import Chip from '@mui/material/Chip'

const chips = {
  quotes: {
    PAID: <Chip label='Paid' color='success' />,
    PENDING: <Chip label='Pending' color='info' />
  },
  orders: {
    READY_FOR_DELIVERY: <Chip label='Ready' color='info' />,
    RECEIVED: <Chip label='Delivered' color='success' />
  },
  support: {
    OPEN: <Chip label='Open' color='info' />,
    RESOLVED: <Chip label='Resolved' color='success' />
  },
  users: {
    USER: (
      <Chip
        label='User'
        variant='outlined'
        // icon={<People />}
      />
    ),
    OPS: (
      <Chip
        label='Ops'
        variant='outlined'
        // icon={<CoPresent />}
      />
    ),
    OWNER: (
      <Chip
        label='Owner'
        variant='outlined'
        // icon={<FaceIcon />}
      />
    ),
    ADMIN: (
      <Chip
        label='Admin'
        variant='outlined'
        // icon={<AdminPanelSettings />}
      />
    ),
    OPSOWNER: (
      <Chip
        label='Ops Owner'
        variant='outlined'
        // icon={<ManageAccountsIcon />}
      />
    ),
    OPSVIEWER: (
      <Chip
        label='Ops Viewer'
        variant='outlined'
        // icon={<ManageAccountsIcon />}
      />
    )
  },
  bills: {
    DUE: <Chip label='Due' color='warning' />,
    PAID: <Chip label='Paid' color='success' />
  }
}

export default chips
